
import { FormikTouched } from "formik"
import { BackupResponseDto, DatabaseResponseDto } from "@/gen/api/backup"
import { CustomizedOption, NetworkConnectionResponseDto, VmSkuResponseDto } from "@/gen/api/deploy"
import { EncryptionResponseDto } from "@/gen/api/encrypt"



export const STASH_DEPLOY_INFO = 'OD/STASH_DEPLOY_INFO'
export const UNSTASH_DEPLOY_INFO = 'OD/UNSTASH_DEPLOY_INFO'



export type DeployOptionSource = 'backup' | 'encryption'



export const initialValues = {
  submit: '',
  database: '' as '' | DatabaseResponseDto,
  deployFrom: 'backup' as DeployOptionSource,
  backupOption: '' as '' | BackupResponseDto,
  encryptionOption: '' as '' | EncryptionResponseDto,
  hostingOption: '' as '' | VmSkuResponseDto,
  instanceName: '',

  networkConnect: '' as '' | NetworkConnectionResponseDto,
  deployCharater: '' as '' | 'production' | 'non-production',
  performanceTier: '' as '' | CustomizedOption,

  initialDBUser: '',
  initialDBPass: '',

  migrateNeeded: true,
  cloneEncryptionMapping: true,
}

export interface StashPayload {
  values: typeof initialValues,
  activeStep: number,
  touched: FormikTouched<typeof initialValues>,
}

export interface StashDeployInfoAction {
  readonly type: typeof STASH_DEPLOY_INFO;
  readonly payload: StashPayload;
}

export interface UnstashDeployInfoAction {
  readonly type: typeof UNSTASH_DEPLOY_INFO;
}



export const raiseStashDeployInfo = (values: typeof initialValues, activeStep: number, touched: FormikTouched<typeof initialValues>): StashDeployInfoAction => ({
  type: STASH_DEPLOY_INFO,
  payload: { values, activeStep, touched },
})


export const raiseUnstashDeployInfo = (): UnstashDeployInfoAction => ({
  type: UNSTASH_DEPLOY_INFO,
})


